import { Divider, Stack, Typography } from "@mui/material";
import React from "react";

const CensadosTotales = ({ listaCensados }) => {
  let censadosCapital = 0;
  let censadosResto = 0;
  for (const person of listaCensados) {
    if (person.departamento === 3218) {
      censadosCapital++;
    } else {
      censadosResto++;
    }
  }
  return (
    <Stack
      sx={{ p: "10px", width: "100%", height: "100%" }}
      flexDirection={"column"}
      justifyContent={"space-between"}
      alignItems={"flex-start"}
    >
      <Typography sx={{ width: "100%" }}
        variant="h5"
        component={"span"}>Total Personas Censadas</Typography>
      <Typography
        sx={{ width: "100%",fontSize:{xs: "50px", md: "80px"} }}
        align="center"
        variant="h1"
        component={"span"}
      >
        {listaCensados.length}
      </Typography>
      <Stack
        sx={{
          width: "100%",
          borderTop: "1px solid rgba(255, 255, 255, 0.15)",
          pt: "5px",
        }}
        flexDirection={"row"}
        justifyContent={"space-evenly"}
        alignItems={"flex-start"}
      >
        <Stack
          sx={{ width: "40%" }}
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
        >
          <Typography sx={{ width: "100%" }}>En Montevideo:</Typography>
          <Typography
            sx={{ width: "100%" }}
            align="center"
            variant="h4"
            component={"span"}
          >
            {censadosCapital}
          </Typography>
        </Stack>

        <Divider orientation="vertical" variant="middle" flexItem />
        <Stack
          sx={{ width: "40%" }}
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
        >
          <Typography sx={{ width: "100%" }}>Resto del País:</Typography>
          <Typography
            sx={{ width: "100%" }}
            align="center"
            variant="h4"
            component={"span"}
          >
            {censadosResto}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CensadosTotales;
